<template>
  <div class="page-stack">
    <section class="exception-summary">
      <div class="exception-icon"><i class="el-icon-warning-outline"></i></div>
      <div>
        <p class="eyebrow">CALLBACK INBOX</p>
        <h2>{{ items.length }} 条待排查回调</h2>
        <p>已可靠落库但未能匹配业务记录，供应商不会因网关重复响应而产生无意义重试。</p>
      </div>
    </section>

    <section class="surface-card">
      <div class="section-head">
        <div>
          <p class="eyebrow">EXCEPTION QUEUE</p>
          <h3>回调异常</h3>
        </div>
        <div class="filter-main">
          <el-input
            v-model.trim="keyword"
            clearable
            prefix-icon="el-icon-search"
            placeholder="Inbox / Call / Ref / 异常码"
            @keyup.enter.native="load"
            @clear="load"
          />
          <el-button icon="el-icon-search" :loading="loading" @click="load">定向查询</el-button>
        </div>
      </div>
      <el-table v-loading="loading" :data="items" class="clean-table" empty-text="当前没有回调异常">
        <el-table-column prop="inboxId" label="Inbox ID" min-width="160" />
        <el-table-column prop="providerCode" label="供应商" min-width="160" />
        <el-table-column prop="eventType" label="事件" width="120" />
        <el-table-column label="关联标识" min-width="190">
          <template slot-scope="{ row }">
            <span class="mono">{{ row.callId || '—' }}</span>
            <small class="table-subline mono">{{ row.refId || '—' }}</small>
          </template>
        </el-table-column>
        <el-table-column label="状态" width="120">
          <template slot-scope="{ row }"><status-tag :status="row.processingStatus" /></template>
        </el-table-column>
        <el-table-column prop="errorCode" label="异常码" min-width="180" />
        <el-table-column label="接收时间" min-width="180">
          <template slot-scope="{ row }">{{ formatDate(row.receivedAt) }}</template>
        </el-table-column>
      </el-table>
    </section>
  </div>
</template>

<script>
import { getCallbackExceptions } from '../api/admin'
import StatusTag from '../components/StatusTag.vue'

export default {
  name: 'CallbackExceptionsView',
  components: { StatusTag },
  data () {
    return { loading: false, items: [], keyword: '' }
  },
  created () {
    this.load()
  },
  methods: {
    async load () {
      this.loading = true
      try {
        this.items = await getCallbackExceptions({
          keyword: this.keyword || undefined,
          limit: 100
        })
      } catch (error) {
        this.$message.error('回调异常加载失败')
      } finally {
        this.loading = false
      }
    },
    formatDate (value) {
      return value ? value.replace('T', ' ') : '—'
    }
  }
}
</script>
